import { atom } from "jotai";
import localStorageManager from "src/utils/localStorageManager";
import type { SelectType } from "./auth.type";

export const select_type_atom = atom<SelectType | null>(null);

export const isLogin_atom = atom(localStorageManager.getItem("token") !== null);
